import {Component, EventEmitter, Input, Output} from '@angular/core';
import {IBloodGroupDto} from '@employee-models/data.models';
import {IThirdPartyContractorGuestRequest} from '../../../../../../../DBadgePrehire-app/src/app/models/data.models';
import {BadgeRequestCategoryEnum} from '@employee-models/data.enums';
import {isPhotoRequiredCategory} from '@employee-pages/badge-request-page/common/photo-required-categories';

interface IThirdPartyContractorGuestRequestValid extends IThirdPartyContractorGuestRequest {
    isValid?: boolean
    entityOrFssName?:string;
    errors?: string[];
}

@Component({
    selector: 'employee-contractor-grid',
    templateUrl: './contractor-grid.component.html',
    styleUrls: ['contractor-grid.component.less']
})
export class ContractorGridComponent {
    @Input() guestsData: IThirdPartyContractorGuestRequestValid[];
    @Input() bloodGroups: IBloodGroupDto[] = [];
    @Input() showAddGuestButton: boolean;
    @Input() categoryId: BadgeRequestCategoryEnum;
    @Output() newGuestForm = new EventEmitter<boolean>();
    @Output() deleteGuestData = new EventEmitter<string>();
    @Output() editGuestData = new EventEmitter<IThirdPartyContractorGuestRequest[]>();
    @Input() isBadgeExtension: boolean = false;
    guestToEdit: IThirdPartyContractorGuestRequest;
    guestIndex: number;
    isEdit = false;

    defaultImageUrl = '../../assets/img/badge-requests/no-photo.svg';

    // addNewGuest(): void {
    //     if (!this.guestToEdit) {
    //         this.newGuestForm.emit(true);
    //     }
    // }
    addNewGuest(isBadgeExtension: boolean = false): void {
    if (!this.guestToEdit) {
        const guestPayload: any = {};
        guestPayload.isBadgeExtension = isBadgeExtension;
        this.newGuestForm.emit(guestPayload);
    }
}

    deleteGuest(guest: IThirdPartyContractorGuestRequest): void {
        if (!this.guestToEdit && this.showAddGuestButton) {
            this.deleteGuestData.emit(`${guest.firstName}${guest.lastName}${guest.phoneNumber}`);
        }
    }

    cancel(isCancel: boolean): void {
        this.guestToEdit = null;
        this.isEdit = false;
        this.guestIndex = null;
    }

    editGuest(updatedGuest: IThirdPartyContractorGuestRequest): void {
        const originalGuest = this.guestsData[this.guestIndex];
        this.guestsData = this.guestsData.filter((item, index) => index !== this.guestIndex);

        this.guestsData = [
            ...this.guestsData.slice(0, this.guestIndex),
            { 
                ...updatedGuest, 
                isValid: true,
                // Preserve isBadgeExtension flag from original guest
                isBadgeExtension: (originalGuest as any).isBadgeExtension || (updatedGuest as any).isBadgeExtension
            } as any,
            ...this.guestsData.slice(this.guestIndex)
        ] as any;
        this.editGuestData.emit(this.guestsData);
        this.cancel(true);
    }

    openEditGuest(guest: IThirdPartyContractorGuestRequest, guestIndex: number): void {
        if (!this.guestToEdit && this.showAddGuestButton) {
            this.guestToEdit = guest;
            this.isEdit = true;
            this.guestIndex = guestIndex;
        }
    }

    hasMissingPhoto(guest: { photoInfo?: any }): boolean {
        return isPhotoRequiredCategory(this.categoryId) && !guest?.photoInfo?.['file']?.url;
    }

}
